import { useContext, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { UFContext } from 'contexts/UFContext';
import { DropsContext } from 'contexts/DropsContext';
import { GridContext } from 'contexts/GridContext';
import { useModal } from 'components/Modals';
import DeleteModal from 'components/Modals/DeleteModal';
import ResumoModal from 'components/Modals/ResumoModal';
import Container from 'components/Container';
import Header from 'components/Header';
import Card from 'components/Card';
import DataView, { useDataViewFilters } from 'components/DataView';
import getUFFilterFields from './filterFields';

const UF = () => {
  const rotina = 'Uf';
  const titulo = 'UF';
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { openModal, closeModal } = useModal();
  const { drops } = useContext(DropsContext);
  const { deleteGrid, exportPdf, exportXls } = useContext(GridContext);
  const { uf, getUF, getLoading } = useContext(UFContext);

  const filterFields = useMemo(() => getUFFilterFields(drops), [drops]);

  const { applyFilter, filterForm } = useDataViewFilters({
    fields: filterFields,
    searchParams,
    setSearchParams,
    onApply: (props) => loadGrid(props),
  });
  const { getValues } = filterForm;

  const loadGrid = (props = {}) => {
    const filter = props?.filter || getValues();

    closeModal();

    getUF({ ...props, rotina, filter });
  };

  const toolbarActions = [
    {
      name: 'Adicionar',
      icon: 'add',
      placement: 'primary',
      action: () => navigate('/app/Tabelas/UF/Manutencao'),
    },
    {
      name: 'Exportar PDF',
      icon: 'file_download',
      action: () =>
        exportPdf({ rotina, filter: getValues(), order: uf?.order }),
    },
    {
      name: 'Exportar XLS',
      icon: 'file_download',
      action: () =>
        exportXls({ rotina, filter: getValues(), order: uf?.order }),
    },
    {
      name: 'Resumo',
      icon: 'summarize',
      action: () =>
        openModal(
          <ResumoModal
            colunas={uf?.colunas}
            onSubmit={(group) =>
              navigate('/app/Resumo', {
                state: { rotina, group, filter: getValues() },
              })
            }
          />
        ),
    },
  ];

  const rowActions = [
    {
      name: 'Editar',
      icon: 'edit',
      action: ({ row: values }) =>
        navigate('/app/Tabelas/UF/Manutencao', {
          state: { values },
        }),
    },
    {
      name: 'Deletar',
      icon: 'delete',
      action: ({ row }) =>
        openModal(
          <DeleteModal
            onSubmit={() =>
              deleteGrid({
                params: { rotina, id: row?.id },
                cb: () => {
                  loadGrid();
                },
              })
            }
          />
        ),
    },
  ];

  return (
    <Container fillHeight>
      <Header
        rotina={rotina}
        titulo={titulo}
        colunas={uf?.colunas}
      />
      <Card fillHeight>
        <DataView
          fillHeight
          grid={uf}
          filterFields={filterFields}
          filterForm={filterForm}
          onFilter={applyFilter}
          toolbarActions={toolbarActions}
          rowActions={rowActions}
          checkboxSelection
          loading={getLoading}
          loadGrid={loadGrid}
        />
      </Card>
    </Container>
  );
};

export default UF;

